import React, { useState, useEffect, useContext } from 'react';
import { Input, Spin, Checkbox } from 'antd';
import { api } from '../../api';
import { FormContext } from '../metadata/MDForm';
import Script from 'react-load-script';
import get from 'lodash/get';
import trim from 'lodash/trim';
import values from 'lodash/values';
import { LoadingOutlined } from '@ant-design/icons';
import {env} from '../../env'


const antIcon = <LoadingOutlined style={{ fontSize: '14px' }} spin />;

const autocomplete = {};
const placeMetadataCache = {};
const placeVerificationCache = {};
const addressMetadataCache = {};
const placeVerificationCacheAddr = {};
const addressTemplate = {
  "id": "id",
  "addrTypeCd": "addrTypeCd",
  "addr1": "addr1",
  "city": "city",
  "stateProvCd": "stateProvCd",
  "postalCode": "postalCode",
  "county": "county",
  "regionCd": "regionCd",
  "regionISOCd": "regionISOCd",
  "verificationHash": "verificationHash",
  "latitude": "latitude",
  "longitude": "longitude",
  "score": "score",
  "dpv": "dpv",
  "dpvDesc": "dpvDesc",
  "dpvNotes": "dpvNotes",
  "dpvNotesDesc": "dpvNotesDesc",
  "barcodeDigits": "barcodeDigits",
  "carrierRoute": "carrierRoute",
  "congressCode": "congressCode",
  "countyCode": "countyCode"
}

const generateAddrValue = (formContext, singleAttributeAddress, address)=>{
  const prefix = getPrefix(singleAttributeAddress);
  const mapping = formContext.metadata[prefix].mapping;
  const rslt = {};
  for(const attr in address ){
    if(attr !== 'id' && attr !== 'addrTypeCd' && prefix !== undefined) {
      const title = mapping + '.'+ attr;
      rslt[title] = address[attr]? address[attr]: undefined;
    }
  }
  const addressObj = formContext.getValueByAttr(prefix);
  if(addressObj && addressObj.hasOwnProperty('addrTypeCd')){
  }else {
    const title = mapping + '.addrTypeCd';
    rslt[title] = prefix;
  }
  return rslt;
}

const serializeAddr = (addr)=>{
  let obj = {};
  for(let k in addr){
    if (addr.hasOwnProperty(k) && k !== 'id' && k !== 'addrTypeCd'){
      obj = {...obj, [k]:addr[k]}
    }
  }
  return obj;
}

function getPlaceMetadata(placeId, addressString) {
  if (typeof placeMetadataCache[placeId] !== 'undefined') {
    return Promise.resolve(placeMetadataCache[placeId]);
  }
  return api
    .get(`/addresses/googlePlacesFill?placeId=${placeId}`)
    .then((v) => {
      placeMetadataCache[placeId] = v;
      addressMetadataCache[addressString] = v;
      return placeMetadataCache[placeId];
    })
    .catch((err) => console.log('Err', err));
}

function getAddressMetadata(addressLine) {
  if(addressLine === '') {
    return Promise.resolve(null);
  }
  if (typeof addressMetadataCache[addressLine] !== 'undefined') {
    return Promise.resolve(addressMetadataCache[addressLine]);
  }
  return api
    .get(`/addresses/googlePlacesFill?addressLine=${encodeURI(addressLine)}`)
    .then((v) => {
      addressMetadataCache[addressLine] = v;
      return addressMetadataCache[addressLine];
    })
    .catch(err => err.response);
}

function getPlaceVerification(placeId, address,addressType='Combined') {
  if (typeof placeVerificationCache[placeId] !== 'undefined') {
    return Promise.resolve(placeVerificationCache[placeId]);
  }
  return api.post(`/addresses/verificationRequest?addressType=${addressType}`, address).then(v => {
    placeVerificationCache[placeId] = v;
    return placeVerificationCache[placeId];
  }).catch(err => err.response);
}

const addressObjToString = (obj) => {
 if (obj && obj.addr1){
    const newAddress = [
      trim(obj.addr1),
      obj.addr2 ? ' ' + trim(obj.addr2) : '',
      ', ' + trim(obj.city),
      ', ' + trim(obj.stateProvCd),
      ', ' + trim(obj.postalCode)
    ].join('');
    return newAddress;
  }else {
    return obj;
  }
};

function getPlaceVerificationAddr(address) {
  const addrStr = addressObjToString(address);
  if (typeof placeVerificationCacheAddr[addrStr] !== 'undefined') {
    return Promise.resolve(placeVerificationCacheAddr[addrStr]);
  }
  const body = address && address.addr1 ? address : {'addr1':address};
  return api.post(`/addresses/verificationRequest`, body).then(v => {
    placeVerificationCacheAddr[addrStr] = v;
    return placeVerificationCacheAddr[addrStr];
  }).catch(err => err.response);
}


export function VerifiedAddress(props) {
  return <Address {...props} verify />;
}

export function Address({
  value,
  verify,
  onChange,
  singleAttributeAddress,
  addressAttributes,
  ...props
}) {
  let {
    setValuesByAttr,
    setValueByAttr,
    getValuesByAttr,
    getValueByAttr,
    setValues
  } = useContext(FormContext);
  const formContext = useContext(FormContext);
  let existingValue;
  let defaultValue;

  let linkAddrParam,linkAddrName, addrTypeParam;
  let hasLookUpAddr = false;

  if (singleAttributeAddress) {
    existingValue = getValueByAttr(getPrefix(singleAttributeAddress));
    defaultValue = existingValue
      && existingValue.addr1
        ? [
          trim(existingValue.addr1),
          existingValue.addr2 ? ' ' + trim(existingValue.addr2) : '',
          ', ' + trim(existingValue.city),
          ', ' + trim(existingValue.stateProvCd),
          ', ' + trim(existingValue.postalCode)
        ].join('')
        : ''
        || '';

     linkAddrParam = formContext.metadata[getPrefix(singleAttributeAddress)].param ? formContext.metadata[getPrefix(singleAttributeAddress)].param.find(i => i.name === 'LinkedAttributeId') : null;
     linkAddrName = linkAddrParam ?  linkAddrParam.value : null;
     addrTypeParam = linkAddrName && formContext.metadata[linkAddrName] && formContext.metadata[linkAddrName].param ? formContext.metadata[linkAddrName].param .find((i) => i.name === 'AddressType'): null;
     hasLookUpAddr = !!addrTypeParam && addrTypeParam.value === 'Lookup';


  } else {
    existingValue = getValuesByAttr(
      Object.keys(addressAttributes),
      addressAttributes
    );
    const hasExistingValue = values(existingValue).filter(v => !v).length <= 2;
    defaultValue = hasExistingValue
      ? [
          trim(existingValue.addr1),
          existingValue.addr2 ? ' ' + trim(existingValue.addr2) : '',
          ', ' + trim(existingValue.city),
          ', ' + trim(existingValue.stateProvCd),
          ', ' + trim(existingValue.postalCode)
        ].join('')
      : '';
  }

  const homeAddr = values(serializeAddr(getValueByAttr("InsuredMailingAddr"))).join(",");
  const billAddr = values(serializeAddr(getValueByAttr(getPrefix(singleAttributeAddress)))).join(",");

  const [componentMeta, setComponentMeta] = useState({
    apiKey: null,
    value: defaultValue,
    verifying: false,
    verified: false,
    errorMessage: null,
    modifying: false,
    scriptUrl: `https://maps.googleapis.com/maps/api/js?key=${env.gooleAPI}&libraries=places`,
  });

  useEffect(() => {
    /* when address copy to InsuredBillingAddr field, try to set address value to field and make it readonly */
    if (JSON.stringify(singleAttributeAddress) === JSON.stringify({attr:"InsuredBillingAddr"})){
      if (defaultValue){
        if (!!homeAddr && !!billAddr && homeAddr === billAddr) {
          setComponentMeta({...componentMeta, value: defaultValue, verified: true, readonly: "readonly"});
        }else {
          setComponentMeta({...componentMeta,value: defaultValue, verified: true,readonly: false})
        }
      }else {
        setComponentMeta({...componentMeta,value: defaultValue, verified: false, readonly:false});
      }

    }
  },[defaultValue,homeAddr,billAddr]);

  function clearAddressAttribute(singleAddress){
    const prefix = getPrefix(singleAddress);
    const mapping = formContext.metadata[prefix].mapping;
    const rslt = {};
    for(const attr in addressTemplate ){
      if(attr !== 'id' && attr !== 'addrTypeCd' && prefix !== undefined) {
        const title = mapping + '.'+ attr;
        rslt[title] = undefined;
      }
    }
    return rslt;
  }

  const onInputChange = e => {
    const addrAttr = singleAttributeAddress ? singleAttributeAddress : Object.keys(addressAttributes)[0];
    if (e.target.value !== componentMeta.value) {
      if(!e.target.value){
        const clearAddress = clearAddressAttribute(singleAttributeAddress);
        setValues(clearAddress);
        formContext.touch(addrAttr, true);
        formContext.validate();
        setComponentMeta({
          ...componentMeta,
          value: e.target.value,
          verified: false,
          errorMessage: null,
          modifying: false
        });
        if(hasLookUpAddr){
          const clearLookUpAddr = clearAddressAttribute({attr: linkAddrName});
          setValues(clearLookUpAddr);
        }
      } else {
        setComponentMeta({
          ...componentMeta,
          value: e.target.value,
          verified: false,
          errorMessage: null
        });
      }
    }
    // if(!componentMeta.value) {
    //   handleScriptLoad();
    // }
  };

  /* onInputBlur and handlePlaceSelect both bind to input tag,
    since onInputBlur has almost same logic as handlePlaceSelect has,
    there is a bug if we bind both of them to input tag
   */
  const onInputBlur = async () => {
    if(!componentMeta.modifying) return;
    const newAddr = componentMeta.value.replace(/(#)/g,"Unit ");
    const metadata = await getAddressMetadata(newAddr);
    if(metadata.status !== 200){
      setComponentMeta({
        ...componentMeta,
        value: "",
        verifying: false,
        verified: false,
        errorMessage: metadata.data.message,
      });
      autocomplete[props.id].unbindAll();
      handleScriptLoad();
      return ;
    }
    let address = metadata.data;
    setComponentMeta({ ...componentMeta, verifying: true });
    let verification = null;
    if (verify) {
      verification = await getPlaceVerificationAddr(address);
      if (verification && verification.status === 200) {
        address = get(verification, 'data.addresses[0]');
      } else {
        address = null;
        setComponentMeta({
          ...componentMeta,
          value: "",
          verifying: false,
          verified: false,
          errorMessage: verification.data.message,
        });
        autocomplete[props.id].unbindAll();
        handleScriptLoad();
        return ;
      }
    }
    if (address) {
      const newAddress = [
        trim(address.addr1),
        address.addr2 ? ' ' + trim(address.addr2) : '',
        ', ' + trim(address.city),
        ', ' + trim(address.stateProvCd),
        ', ' + trim(address.postalCode)
      ].join('');
      if (singleAttributeAddress) {
        setValueByAttr(singleAttributeAddress.attr, newAddress);
      } else {
        const model = createAddressModelFromObj(address, addressAttributes);
        setValuesByAttr(model);
      }
      setComponentMeta({
        ...componentMeta,
        value: newAddress,
        verifying: false,
        verified: true
      });
    }
  }

  const handleScriptLoad = () => {
    const options = {
      types: [`address`]
    };

    /*global google*/ autocomplete[
      props.id
    ] = new google.maps.places.Autocomplete(
      document.getElementById(props.id),
      options
    );

    autocomplete[props.id].setFields(['address_component', 'adr_address', 'formatted_address', 'place_id', 'name']);  // reduce our API costs
    autocomplete[props.id].addListener('place_changed', handlePlaceSelect);
  };

  const handlePlaceSelect = async () => {
    setComponentMeta({ ...componentMeta, verifying: true });
    let address;
    let lookupAddr;
    let verification = null;


    const place = autocomplete[props.id].getPlace();
    if (autocomplete[props.id]){

      if (place && place.place_id){
        const metadata = await getPlaceMetadata(place.place_id, componentMeta.value);
        address = metadata.data;
        if (verify) {
          verification = await getPlaceVerification(place.place_id, address);
        }
      }else {
        address = place ? place.name : null;
        if (verify) {
          verification = await getPlaceVerificationAddr(address);
        }
      }
    }else {
      address = componentMeta.value;
      if (verify) {
        verification = await getPlaceVerification(place.place_id, address);
      }
    }

    if (verification && verification.status === 200) {
      address = get(verification, 'data.addresses[0]');

      //If verification of addressAttribute passes check to see if there is a lookupaddr linked to this address.  If there is verify it to get the parts that make up
      //the lookup addr
      if(hasLookUpAddr){
        let lookupAddrVerification = await  getPlaceVerification(`${place.place_id}_Uncombined`, address,'Uncombined');
        if (lookupAddrVerification && lookupAddrVerification.status === 200) {
          lookupAddr = get(lookupAddrVerification, 'data.addresses[0]');
        }else{
          lookupAddr = null;
          const clearLookUpAddr = clearAddressAttribute({attr: linkAddrName});
          setValues(clearLookUpAddr);
        }
      }
    } else {
      // clear out the address and it's corressponding lookupAddr (if there is one)
      address = null;
      const clearAddress = clearAddressAttribute(singleAttributeAddress);
      setValues(clearAddress);
      if(hasLookUpAddr){
        lookupAddr = null;
        const clearLookUpAddr = clearAddressAttribute({attr: linkAddrName});
        setValues(clearLookUpAddr);
      }
      setComponentMeta({
        ...componentMeta,
        value: "",
        verifying: false,
        verified: false,
        modifying: true,
        errorMessage: verification.data.message,
      });
      autocomplete[props.id].unbindAll();
      handleScriptLoad();
      return ;
    }

    if (address) {
      const newAddress = [
        trim(address.addr1),
        address.addr2 ? ' ' + trim(address.addr2) : '',
        ', ' + trim(address.city),
        ', ' + trim(address.stateProvCd),
        ', ' + trim(address.postalCode)
      ].join('');
      if (singleAttributeAddress) {
        const rslt = generateAddrValue(formContext, singleAttributeAddress, address);
        setValues(rslt);
        const firstKey = singleAttributeAddress.attr;
        formContext.touch(firstKey, true);

        if(lookupAddr){
          const rslt = generateAddrValue(formContext, {attr: linkAddrName}, lookupAddr);
          setValues(rslt);
        }
      } else {
        const model = createAddressModelFromObj(address, addressAttributes);
        setValuesByAttr(model);
      }
      setComponentMeta({
        ...componentMeta,
        value: newAddress,
        verifying: false,
        verified: true,
        modifying: true
      });
      autocomplete[props.id].unbindAll();
      handleScriptLoad();
    }

  };

  /* clear error massage when input is on blur*/
  const handleOnBlur = ()=>{
    setComponentMeta({
      ...componentMeta,
      errorMessage: null,
    });
  }

  return (
    <React.Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          borderColor: componentMeta.errorMessage ? 'red' : null
        }}
      >
        {componentMeta.scriptUrl && (
          <Script url={componentMeta.scriptUrl} onLoad={handleScriptLoad} />
        )}
        <Input
          id={props.id}
          type='text'
          value={componentMeta.value}
          readOnly={componentMeta.readonly}
          onChange={onInputChange}
          suffix={componentMeta.verifying && <Spin indicator={antIcon} />}
          style={{ borderColor: componentMeta.errorMessage ? 'red' : null }}
          onBlur={handleOnBlur}
        />
      </div>
      <div style={{ flexDirection: 'column' }}>
        {componentMeta.verified && (
          <span className='fieldSuccess'>Address has been verified</span>
        )}
      </div>
      <div style={{ flexDirection: 'column' }}>
        {componentMeta.errorMessage && (
          <span role={"alert"} className='fieldError'>{componentMeta.errorMessage}</span>
        )}
      </div>
    </React.Fragment>
  );
}

function createAddressModelFromObj(obj, addressAttributesMap) {
  const result = {};
  for (const attrName in addressAttributesMap) {
    if (addressAttributesMap.hasOwnProperty(attrName)) {
      const propertyName = addressAttributesMap[attrName];
      result[attrName] = obj[propertyName] || '';
    }
  }
  return result;
}
/*
*  @getPrefix(singleAttributeAddress);
*  @returns: prefix for api metadata mapping
*
* */
function getPrefix(singleAttributeAddress){
  return (null != singleAttributeAddress
      && '' !== singleAttributeAddress ?
      singleAttributeAddress.attr : undefined);
}

export function BillingAddressCheckbox({
  addressAttributes,
  homeAddrAttr,
  props,
}) {
  let { getValuesByAttr, setValues } = useContext(FormContext);
  const formContext = useContext(FormContext);
  let homeAddr = values(serializeAddr(getValuesByAttr(Object.keys(homeAddrAttr), homeAddrAttr).addr1)).join(",");
  let billAddr = values(serializeAddr(getValuesByAttr(Object.keys(addressAttributes), addressAttributes).addr1)).join(",")

  const isAddressValid = ()=>{
    let valid = false;
    homeAddr.split(",").forEach(x=>{
      if (x !== "" && x !== ","){
        valid = true;
      }
    })
    return valid;
  }

  const [componentMeta, setComponentMeta] = useState({
    checked: isAddressValid(homeAddr) && homeAddr === billAddr,
  });

  useEffect(()=>{
    setComponentMeta({checked: isAddressValid(homeAddr) && homeAddr === billAddr})
  },[billAddr,homeAddr])

  const onChange = (e) => {
    setComponentMeta({
      ...componentMeta,
      checked: e.target.checked,
    });
    if (e.target.checked) {
      setBillingAddr();
    }else {
      clearBillingAddr();
    }
  };

  const clearBillingAddr = ()=>{
    const emptyAddress = {};
    for (let k in addressTemplate){
      emptyAddress[k] = '';
    }
    setAddrValues(emptyAddress);
  }

  const setBillingAddr = () => {
    const addr = getValuesByAttr(Object.keys(homeAddrAttr), homeAddrAttr).addr1;
    billAddr = addr;
    setAddrValues(billAddr);
  };

  const setAddrValues = (homeAddr) => {
    const singleAttributeAddress = {attr: "InsuredBillingAddr"};
    const rslt = generateAddrValue(formContext, singleAttributeAddress, homeAddr);
    setValues(rslt);
    const firstKey = singleAttributeAddress.attr;
    formContext.touch(firstKey, true);
    formContext.validate();
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Checkbox
        style={{ marginBottom: '1em' }}
        onChange={onChange}
        checked={componentMeta.checked}
      >
        Use Home Address for Billing Address
      </Checkbox>
    </div>
  );
}